"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTipDisplaySideFactProperty = exports.tipDisplaySideFactPropertyDefinition = void 0;
exports.tipDisplaySideFactPropertyDefinition = {
    view: {
        label: 'Display as Sidefact',
        style: 'toggle',
    },
    constraints: [],
    type: 'boolean',
    multiple: false,
    default: true,
    name: 'tip-display-sidefact',
};
const isTipDisplaySideFactProperty = (prop) => {
    return prop.name === exports.tipDisplaySideFactPropertyDefinition.name;
};
exports.isTipDisplaySideFactProperty = isTipDisplaySideFactProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwLWRpc3BsYXktc2lkZWZhY3QucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90aXAtZGlzcGxheS1zaWRlZmFjdC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLG9DQUFvQyxHQUFHO0lBQ2xELElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxxQkFBcUI7UUFDNUIsS0FBSyxFQUFFLFFBQVE7S0FDaEI7SUFDRCxXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxTQUFTO0lBQ2YsUUFBUSxFQUFFLEtBQUs7SUFDZixPQUFPLEVBQUUsSUFBSTtJQUNiLElBQUksRUFBRSxzQkFBc0I7Q0FDRyxDQUFBO0FBSTFCLE1BQU0sNEJBQTRCLEdBQUcsQ0FBQyxJQUFrQixFQUFzQyxFQUFFO0lBQ3JHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw0Q0FBb0MsQ0FBQyxJQUFJLENBQUE7QUFDaEUsQ0FBQyxDQUFBO0FBRlksUUFBQSw0QkFBNEIsZ0NBRXhDIn0=